import * as React from 'react';
import { get } from 'lodash';

import Page from 'components/page/Page';
import SVGDynamicIcon from 'components/svg-dynamic-icon/SVGDynamicIcon';

import AccessContainer from '../components/access-container/AccessContainer';

import { t } from 'utils/language';

type Props = {
  location: {
    query: {
      next: string
    }
  }
};

const SignUpSuccessfulPage = (
  {
    location
  }: Props
): JSX.Element => (
  <Page
    documentTitle={t('signup_page')}
  >
    <AccessContainer type="signup-success">
      <p className="access-container__icon">
        <SVGDynamicIcon
          name="checkmark-inside-circle-white-bg-custom-fg"
          width={116}
          height={116}
          customColor="primary"
        />
      </p>
      <p className="access-container__description">
        {t('signup_successful_title')}
      </p>
      <p className="access-container__description">
        {
          get(location, 'query.next') === 'support' ?
            t('signup_successful_support_message') :
            t('signup_successful_message')
        }
      </p>
    </AccessContainer>
  </Page>
);

export default SignUpSuccessfulPage;
